<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Noticias</h2>
                </div>
                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Noticias</li>
                     
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section *ngIf="newsList" class="blog-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div *ngIf="newsList.length === 0" class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="single-blog-post">
                            <div class="blog-content-wrap">
                                <a><i class="fas fa-info-circle"></i> No existen coincidencias para el criterio de búsqueda proporcionado <strong>"{{searched}}"</strong>.</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="newsList.length !== 0" class="row">

        
                    <div *ngFor="let item of newsList" class="col-lg-6 col-md-6">
                        <div class="single-blog-post">
                            <a class="d-block"><img src="{{item.imageUrl}}" alt="Image"></a>
        
                            <div class="blog-content-wrap">
                                <ul >
                                    <li style="cursor: pointer;" title="{{item.authorName}}"><a><i class="flaticon-male"></i> {{item.authorName | truncate:12}}</a></li>
                                    <li class="date"><i class="flaticon-appointment"></i>{{item.postedOn | date: 'dd MMMM y' }}</li>
                                </ul>
                                <h5><a>{{item.title}}</a></h5>
                                <p>{{item.summary | truncate:200}}</p>
        
                                <a (click)="goToNews(item)" class="read-more pointer">Leer más<i class="bx bx-chevron-right"></i></a>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-12">
                        <div class="page-navigation-area">
                            <nav>
                                <ul class="pagination">
                                    <li class="pointer page-item" [class.disabled]="currentPage === 1">
                                        <a class="page-link page-links" (click)="changePage(currentPage - 1)" >
                                            <i class="bx bx-chevrons-left"></i>
                                        </a>
                                    </li>
                                    <li *ngFor="let page of totalPagesArray" class="pointer page-item" [class.active]="page === currentPage">
                                        <a class="page-link" (click)="changePage(page)">{{ page }}</a>
                                    </li>
                                    <li class="pointer page-item" [class.disabled]="currentPage === totalPages">
                                        <a class="page-link" (click)="changePage(currentPage + 1)" >
                                            <i class="bx bx-chevrons-right"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <aside class="widget-area" id="secondary">
                    <div class="widget widget_search mt-0">
                        <h3 class="widget-title">Buscar</h3>

                        <div class="post-wrap">
                            <form class="search-form">
                                <label>
                                    <span class="screen-reader-text">Search for:</span>
                                    <input [(ngModel)]="searchInput" name="searchInput"  type="search" class="search-field" placeholder="Titulo o Contenido...">
                                </label>
                                <button (click)="searchByTitleOrContent()"><i class='bx bx-search'></i></button>
                            </form>
                        </div>
                    </div>

                    <section class="widget widget-hosta-posts-thumb">
                        <h3 class="widget-title">Populares</h3>

                        <div class="post-wrap-without-overflow">
                         
                            
                            <article (click)="goToNews(item)" *ngFor="let item of topNews" class="item pointer">
                                <a class="thumb">
                                    
                                    <div class="article-image">
                                        <img src="{{item.image}}" alt="image">
                                    </div>
                                </a>
                                <div class="info">
                                    <time>{{item.postedOn | date: 'dd MMMM y' }}</time>
                                    <h4 class="title usmall">
                                        <a >
                                            {{item.title}}
                                        </a>
                                    </h4>
                                </div>

                                <div class="clear"></div>
                            </article>
                  
                            
                          
                        </div>
                    </section>

                    <section class="widget widget_categories">
                        <h3 class="widget-title">Archivo</h3>

                        <div class="post-wrap">
                            <ul>
                                <li [ngClass]="{ 'isActive': item.isActive }" class="pointer" *ngFor="let item of archives" (click)="searchByArchive(item)">
                                    <a >{{item.dateParsed}} <span>({{item.news}})</span></a>
                                  </li>
                            </ul>
                        </div>
                    </section>
                    
                    <section class="widget widget_categories">
                        <h3 class="widget-title">Categorías</h3>

                        <div class="post-wrap">
                            <ul>
                                <li [ngClass]="{ 'isActive': item.isActive }" class="pointer" *ngFor="let item of categories" (click)="searchByCategory(item)">
                                    <a>{{item.category | uppercase }} <span>({{item.news}})</span></a>
                                  </li>
                            </ul>
                        </div>
                    </section>
                </aside>
            </div>
        </div>
    </div>
</section>